import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex-1 text-align-right" }
const _hoisted_2 = { class: "text-ellipsis" }

import {ProjectDialog, QrDialog} from "@/components/views/kh";
  import {ref, onMounted} from "vue";
  import {useTimeFormat} from "@hview/hview-vue3/packages";
  import {getProjectListApi} from "@/api/kh";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

  const {timeFormat} = useTimeFormat();
  const uiModel = ref({
    loading: false,
    list: []
  });

  const qrDialogRef = ref();
  const projetDialogRef = ref();


  const showQrCode = (data: any) => {
    qrDialogRef.value.open(data);
  }


  /**
   * @description 加载数据
   */
  const load = () => {
    uiModel.value.loading = true;
    getProjectListApi().then((res: any) => {
      const data = res.data;
      uiModel.value.list = data;
    }).finally(() => {
      uiModel.value.loading = false;
    });
  }

  const openDialog = (data: any) => {
    projetDialogRef.value.open(data.id);
  }

  const addProject = () => {
    projetDialogRef.value.create();
  }


  onMounted(() => {
    load();
  });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_h_dict = _resolveComponent("h-dict")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_h_container = _resolveComponent("h-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_h_container, {
    isTable: "",
    title: "项目列表"
  }, {
    "extra-header": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: addProject
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("添加项目")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: uiModel.value.list,
        stripe: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            label: "编号",
            "header-align": "center",
            align: "center",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "project_name",
            "header-align": "center",
            align: "center",
            label: "项目名称",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            prop: "project_desc",
            "header-align": "center",
            align: "center",
            label: "项目描述",
            "min-width": "230"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tooltip, {
                class: "item",
                effect: "dark",
                content: scope.row.project_desc,
                placement: "bottom-start"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(scope.row.project_desc), 1)
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "createtime",
            "header-align": "center",
            align: "center",
            label: "创建时间",
            width: "180"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(timeFormat)(scope.row.createtime, "yyyy-mm-dd hh:MM:ss")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "updatetime",
            "header-align": "center",
            align: "center",
            label: "修改时间",
            width: "180"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(timeFormat)(scope.row.updatetime, "yyyy-mm-dd hh:MM:ss")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "status",
            "header-align": "center",
            align: "center",
            label: "状态"
          }, {
            default: _withCtx((scope) => [
              (scope.row.status == 'normal')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: scope.row.status == 'normal' ? 'success' : 'danger'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_h_dict, {
                        mode: "text",
                        dictKey: "status_type",
                        modelValue: scope.row.status,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.status) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["type"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "address",
            label: "操作",
            align: "center",
            "header-align": "center",
            fixed: "right",
            width: "260"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: ($event: any) => (openDialog(scope.row)),
                link: ""
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: ($event: any) => (showQrCode(scope.row)),
                link: ""
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("查看二维码")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, uiModel.value.loading]
      ]),
      _createVNode(_unref(QrDialog), {
        ref_key: "qrDialogRef",
        ref: qrDialogRef,
        onVnodeBeforeMount: _ctx.onVnodeBeforeMountRef_
      }, null, 8, ["onVnodeBeforeMount"]),
      _createVNode(_unref(ProjectDialog), {
        ref_key: "projetDialogRef",
        ref: projetDialogRef,
        onVnodeBeforeMount: _ctx.onVnodeBeforeMountRef_,
        onOnLoad: load
      }, null, 8, ["onVnodeBeforeMount"])
    ]),
    _: 1
  }))
}
}

})